import { createRoute, useNavigate } from '@tanstack/react-router'
import rootRoute from './rootRoute'
import type { Entity } from '@/lib/types'
import type { components } from '@/lib/client'
import { errorToast, toast } from '@/components/ui'
import { adminRouteLoader } from '@/lib/auth'
import EntityForm from '@/components/EntityForm'
import { entitySlug } from '@/lib/helpers'
import { $client } from '@/lib/fetch'

type CreateEntity = components['schemas']['CreateEntityInputBody']

function NewEntity() {
  const navigate = useNavigate()

  const onCreate = async (data: CreateEntity) => {
    const { error, data: created } = await $client.POST('/api/entities', {
      body: data,
    })

    if (error) {
      if (error.detail === 'validation failed') {
        const named: Record<string, string> = {}
        error.errors?.forEach((e) => {
          const [, name] = (e.location || '').split('body.')
          if (e.message) named[name || ''] = e.message
        })
        return named
      }
      errorToast("Échec de la création de l'entité", error)
      return
    }

    toast({ color: 'success', title: 'Entité créée avec succès !' })
    navigate({
      to: '/communautes/$slug',
      params: { slug: entitySlug(created.entity.id, created.entity.name) },
    })
  }

  const defaultEntity: Entity = {
    id: 0,
    name: '',
    description: '',
    kind_id: 0,
    tags: [],
    requires_autofill: false,
  }

  return (
    <EntityForm
      label="Nouvelle entité"
      entity={defaultEntity}
      onSubmit={onCreate}
    />
  )
}

export const entityCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/entities/new',
  loader: adminRouteLoader as any,
}).lazy(() => import('./EntityCreatePage.lazy').then((m) => m.Route))

export default NewEntity
